import GithubImages from './images/logotipo-do-github.svg'
import LinkedinImages from './images/linkedin.svg'
import React from "react";
import {Translator} from "./i18n";
function Footer() {
    return (
        <div className="px-4 pt-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
            <div className="grid gap-12 row-gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4">
                <div className="sm:col-span-2">
                    <span className="ml-2 text-xl font-bold tracking-wide text-gray-800 uppercase">
                        <Translator path="footer.contact" />
                    </span>
                    <div className="mt-6 lg:max-w-sm">
                        <p className="text-sm text-gray-800">
                            <div className="flex items-center">
                            <img src={GithubImages} alt="Github logo" className='w-8'/>
                            <a href="https://github.com/edmarr2" className="px-2">
                                GitHub
                            </a>
                            </div>

                            <br/>
                            <div className="flex items-center">
                                <img src={LinkedinImages} alt="Linkedin logo" className='w-8'/>
                                <a href="https://www.linkedin.com/in/edmar-espinola-3a17234a/" className="px-2">
                                    Linkedin
                                </a>
                            </div>
                        </p>
                    </div>
                </div>
                <div className="space-y-2 text-sm">
                    <div className="flex">
                        <p className="mr-1 text-gray-800"><Translator path="footer.phone" />:</p>
                        <a
                            href="tel:850-123-5021"
                            aria-label="Our phone"
                            title="Our phone"
                            className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800"
                        >
                            +55 (67) 9-98635691
                        </a>
                    </div>
                    <div className="flex">
                        <p className="mr-1 text-gray-800"><Translator path="footer.email" /></p>
                        <a
                            href="mailto:info@lorem.mail"
                            aria-label="Our email"
                            title="Our email"
                            className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800"
                        >
                            edmar_espinola@hotmail.com
                        </a>
                    </div>
                    <div className="flex">
                        <p className="mr-1 text-gray-800"><Translator path="footer.address" /></p>
                        <a
                            href="https://www.google.com/maps"
                            rel="noopener noreferrer"
                            aria-label="Our address"
                            title="Our address"
                            className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800"
                        >
                            185 Dourados-MS, BR
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;

